import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
// Public event/news pages do not mount MobileAuthProvider; acknowledge an
// authenticated push interaction without changing their public navigation.
export const NotificationReadReceipt = () => {
  const location = useLocation();
  useEffect(() => {
    if (location.pathname.startsWith("/app")) return;
    const id = new URLSearchParams(location.search).get("notification_id");
    const token = localStorage.getItem("mobile_token");
    if (!token || !/^[A-Za-z0-9_-]{1,120}$/.test(id || "")) return;
    axios.post(`${API}/mobile/notifications/${id}/read`, {}, {headers:{Authorization:`Bearer ${token}`}})
      .then(() => window.dispatchEvent(new Event("notifications-updated")))
      .catch(() => {}); // Public content remains available if the session expired.
  }, [location.pathname, location.search]);
  return null;
};